import * as React from 'react';
import { ITabDetailsProps } from './types';
import './_TabDetails.scss';
import {
    CLASS_CARD_DETAILS,
    CLASS_CARD_DETAILS_READ_ONLY,
    CLASS_SECTION_ICON_PROGRESS_PRIORITY,
    CLASS_SECTION_ICON_PROGRESS_PRIORITY_WATCH,
    CLASS_SECTION_TITLE,
    CLASS_SECTION_WATCH
} from '../../../constants';
import { CardAuthorHOC } from '../../../Author/hocs/CardAuthorHOC/CardAuthorHOC';
import { CardWatchHOC } from '../../../Watch/hocs/CardWatchHOC/CardWatchHOC';
import { CardIconHOC } from '../../../Icon/hocs/CardIconHOC/CardIconHOC';
import { CardColorTagsHOC } from '../../../ColorTags/hocs/CardColorTagsHOC/CardColorTagsHOC';
import { CardNameHOC } from '../../../Name/hocs/CardNameHOC/CardNameHOC';
import { CardDescriptionHOC } from '../../../DescriptionSection/hocs/CardDescriptionHOC/CardDescriptionHOC';
import { AssigneesSectionHOC } from '../../../AssigneesSection/hocs/AssigneesSectionHOC/AssigneesSectionHOC';
import { CardSubcardsSectionHOC } from '../../../SubcardsSection/hocs/CardSubcardsSectionHOC/CardSubcardsSectionHOC';
import { CardRelatedSectionHOC } from '../../../RelatedSection/hocs/CardRelatedSectionHOC/CardRelatedSectionHOC';
import { CardTagsSectionHOC } from '../../../TagsSection/hocs/CardTagsSectionHOC/CardTagsSectionHOC';
import { CommentsSectionHOC } from '../../../CommentsSection/hocs/CommentsSectionHOC/CommentsSectionHOC';
import {
    DependenciesSectionHOC
} from '../../../DependenciesSection/hocs/DependenciesSectionHOC/DependenciesSectionHOC';
import {
    CardAttachmentsSectionHOC as CardAttachmentsSectionHOCgoogle
} from '../../../AttachmentsSection/hocs/CardAttachmentsSectionHOC/CardAttachmentsSectionHOC';
import {
    CardAttachmentsSectionHOC as CardAttachmentsSectionHOCmicrosoft
} from '../../../AttachmentsSection/hocs/microsoft/CardAttachmentsSectionHOC/CardAttachmentsSectionHOC';
import {
    CardEstimateAndSpentTimeSectionHOC
} from '../../../EstimateAndSpentTimeSection/hocs/CardEstimateAndTimeHOC/CardEstimateAndSpentTimeSectionHOC';
import { ListSelectHOC } from '../../../ListSelect/hocs/ListSelectHOC/ListSelectHOC';
import { CardDatesSectionHOC } from '../../../DatesSection/hocs/CardDatesSectionHOC/CardDatesSectionHOC';
import { ESettingsSectionType } from '../../../../../base/components/SettingsSection/types';
import { CardChecklistsHOC } from '../../../ChecklistSection/hocs/CardChecklistsHOC/CardChecklistsHOC';
import {
    CardEpicInHeadSectionHOC
} from '../../../EpicInHeadSection/hocs/CardEpicInHeadSectionHOC/CardEpicInHeadSectionHOC';
import {
    DeleteButtonSectionHOC
} from '../../../DeleteButtonSection/hocs/DeleteButtonSectionHOC/DeleteButtonSectionHOC';
import {
    CustomPropertiesSectionHOC
} from '../../../CustomPropertiesSection/hocs/CustomPropertiesSectionHOC/CustomPropertiesSectionHOC';
import {
    ActionsInHeadSectionHOC
} from '../../../ActionsInHeadSection/hocs/ActionsInHeadSectionHOC/ActionsInHeadSectionHOC';
import { EAuthUserPlatformType } from 'app/types/rest/IRestAuthUser';
import { CardBoardNameHOC } from '../../../CardBoardName/hocs/CardBoardNameHOC/CardBoardNameHOC';
import { CardPriorityHOC } from '../../../../../base/components/CardPriority/hocs/CardPriorityHOC/CardPriorityHOC';
import { root } from '../../../../../../../store/constants';
import {
    ASIDE_COLUMN_MAX_WIDTH,
    ASIDE_COLUMN_MIN_WIDTH, ASIDE_MAX_WIDTH,
    COMMENTS_COLUMN_VIEW_MIN_WIDTH,
    GOOGLE_SPACING
} from '../../../../../../../const';
import { AsidePanelContext } from '../../../../asidePanel/components/AsidePanel/constants';
import Draggable, { DraggableData, DraggableEvent } from 'react-draggable';
import { CLASS_ASIDE_PANEL_ACTIONS_SCROLL } from '../../../../asidePanel/components/AsidePanelActions/constants';
import { v4 as uuidv4 } from 'uuid';
import { CLASS_ASIDE_PANEL, CLASS_ASIDE_PANEL_DRAGGING } from '../../../../asidePanel/constants';

export function TabDetails({
    asideWidth,
    boardId,
    cardId,
    columnWidth,
    isActionsMinimized,
    isCommentColumnView,
    isShow,
    platformType,
    sectionType,
    onChangeColumnWidth,
    onTurnOffColumnView,
}: ITabDetailsProps) {
    if (!isShow) {
        return null;
    }

    const { isScrollDisabled } = React.useContext(AsidePanelContext);

    let CardAttachmentsSectionHOC;
    switch (platformType) {
        case EAuthUserPlatformType.MICROSOFT:
            CardAttachmentsSectionHOC = CardAttachmentsSectionHOCmicrosoft;
            break;
        default:
            CardAttachmentsSectionHOC = CardAttachmentsSectionHOCgoogle;
    }

    const isReadonly = sectionType === ESettingsSectionType.READONLY;
    const className = CLASS_CARD_DETAILS;
    const classNameReadonly = isReadonly ? CLASS_CARD_DETAILS_READ_ONLY : '';
    const classContainer = className + '__container';

    const classNameSectionAuthorAndList = CLASS_CARD_DETAILS + '-author-and-list';

    const [isColumns, setColumns] = React.useState(null);
    React.useEffect(() => {
        const onResize = () => {
            setColumns(isCommentColumnView && root._innerWidth > COMMENTS_COLUMN_VIEW_MIN_WIDTH);
        };
        onResize();
        root.addEventListener('resize', onResize);
        return () => root.removeEventListener('resize', onResize);
    }, [isCommentColumnView, isScrollDisabled]);

    const columnWidthRef = React.useRef(columnWidth);
    React.useEffect(() => {
        columnWidthRef.current = columnWidth;
    }, [columnWidth]);

    const [resizerKey, setResizerKey] = React.useState('resizer-key');
    const resizer = React.useRef({
        actionsWidth: 0,
        minWidth: ASIDE_COLUMN_MIN_WIDTH,
        maxWidth: ASIDE_COLUMN_MAX_WIDTH,
        width: 0,
        x: 0,
    });
    const resizerRef = React.useRef(null);
    const resizerDebounce = React.useRef(null);
    const preventResizeRef = React.useRef(null);
    let resizerTime = React.useRef(0);

    const onMouseMove = React.useCallback(({ x }: MouseEvent) => {
            if (preventResizeRef.current) return;
            const hideOffset = GOOGLE_SPACING * 14;
            const innerWidth = root._innerWidth;
            const { actionsWidth } = resizer.current;
            if (x > innerWidth - ASIDE_COLUMN_MIN_WIDTH - actionsWidth - GOOGLE_SPACING + hideOffset) {
                preventResizeRef.current = true;
                setTimeout(() => {
                    onTurnOffColumnView();
                }, 0);
                setTimeout(() => {
                    preventResizeRef.current = false;
                }, 200);
                setTimeout(() => {
                    handleResizerDragStop(null, null, true);
                }, 200);
            }
    }, []);

    const _handleResizerDrag = (
        draggableData: DraggableData,
    ) => {
        if (preventResizeRef.current) return;
        resizer.current.x = draggableData.x;
        let newColumnWidth = columnWidthRef.current - resizer.current.x;
        if (newColumnWidth < ASIDE_COLUMN_MIN_WIDTH) {
            newColumnWidth = ASIDE_COLUMN_MIN_WIDTH;
        } else if (newColumnWidth > ASIDE_COLUMN_MAX_WIDTH) {
            newColumnWidth = ASIDE_COLUMN_MAX_WIDTH;
        }
        columnWidthRef.current = newColumnWidth;
        onChangeColumnWidth(newColumnWidth);
        const content = document.querySelector('.content__inner') as HTMLElement;
        if (!content) return;
        const w = Math.min(asideWidth + columnWidth + resizer.current.actionsWidth, content.offsetWidth - GOOGLE_SPACING * 4);
        root.App.controller.mainView.setAsidePanelWidth(w + 'px');
        resizerTime.current = Date.now();
    };

    const handleResizerDrag = (
        e: DraggableEvent,
        draggableData: DraggableData,
    ) => {
        const delay = 50;
        if (resizerDebounce.current) clearTimeout(resizerDebounce.current);
        if (Date.now() - resizerTime.current > delay) {
            _handleResizerDrag(draggableData);
        } else {
            resizerDebounce.current = setTimeout(() => _handleResizerDrag(draggableData), delay);
        }
    };

    const handleResizerDragStop = (
        e: DraggableEvent,
        draggableData: DraggableData,
        reset?: boolean,
    ) => {
        document.removeEventListener('mousemove', onMouseMove);
        const aside = document.querySelector('.' + CLASS_ASIDE_PANEL) as HTMLElement;
        if (aside) {
            aside.classList.remove(CLASS_ASIDE_PANEL_DRAGGING);
        }
        if (resizerDebounce.current) clearTimeout(resizerDebounce.current);
        if (reset) {
            root.App.controller.mainView.setAsidePanelWidth(asideWidth + resizer.current.actionsWidth + 'px');
            setResizerKey(uuidv4());
        } else if (resizer.current.x) {
            resizer.current.x = 0;
            let columnWidth = columnWidthRef.current - resizer.current.x;
            if (columnWidth > ASIDE_COLUMN_MAX_WIDTH) {
                columnWidth = ASIDE_COLUMN_MAX_WIDTH;
            } else if (columnWidth < ASIDE_COLUMN_MIN_WIDTH) {
                columnWidth = ASIDE_COLUMN_MIN_WIDTH;
            }
            columnWidthRef.current = columnWidth;
            onChangeColumnWidth(columnWidth);
            const content = document.querySelector('.content__inner') as HTMLElement;
            if (!content) return;
            const w = Math.min(asideWidth + columnWidth + resizer.current.actionsWidth, content.offsetWidth - GOOGLE_SPACING * 4);
            root.App.controller.mainView.setAsidePanelWidth(w + 'px');
            setResizerKey(uuidv4());
        }
    };

    React.useEffect(() => {
        requestAnimationFrame(() => {
            const asidePanelActions = document.querySelector('.' + CLASS_ASIDE_PANEL_ACTIONS_SCROLL) as HTMLElement;
            if (asidePanelActions) {
                resizer.current.actionsWidth = asidePanelActions.offsetWidth || 0;
            }

            resizer.current.minWidth = ASIDE_COLUMN_MIN_WIDTH + resizer.current.actionsWidth;
            resizer.current.maxWidth = ASIDE_COLUMN_MAX_WIDTH + resizer.current.actionsWidth;

            if (resizerRef.current) resizerRef.current.style.right = columnWidth + resizer.current.actionsWidth;
            setResizerKey(uuidv4());
        });
    }, [isActionsMinimized, asideWidth]);

    const body = <>
        <CardBoardNameHOC cardId={cardId} boardId={boardId} />
        <CardEpicInHeadSectionHOC boardId={boardId} cardId={cardId}/>

        <div className={classNameSectionAuthorAndList}>
            <CardAuthorHOC boardId={boardId} cardId={cardId}/>
            <ListSelectHOC boardId={boardId} cardId={cardId}/>
        </div>

        <div className={CLASS_SECTION_ICON_PROGRESS_PRIORITY_WATCH}>
            <div className={CLASS_SECTION_ICON_PROGRESS_PRIORITY}>
                <CardIconHOC cardId={cardId}/>
                <CardPriorityHOC cardId={cardId} isShowBoardLimitSnackbar />
            </div>
            <div className={CLASS_SECTION_WATCH}>
                <CardWatchHOC cardId={cardId} boardId={boardId}/>
            </div>
        </div>

        <CardColorTagsHOC
            boardId={boardId}
            cardId={cardId}
        />

        <div className={CLASS_SECTION_TITLE}>
            <CardNameHOC cardId={cardId} boardId={boardId}/>
            <CardDescriptionHOC cardId={cardId}/>
        </div>

        <AssigneesSectionHOC
            boardId={boardId}
            cardId={cardId}
        />

        <CardTagsSectionHOC
            boardId={boardId}
            cardId={cardId}
        />

        <CardDatesSectionHOC
            boardId={boardId}
            cardId={cardId}
        />

        <CardEstimateAndSpentTimeSectionHOC
            boardId={boardId}
            cardId={cardId}
        />

        <CardChecklistsHOC
            boardId={boardId}
            cardId={cardId}
        />

        <CardAttachmentsSectionHOC
            boardId={boardId}
            cardId={cardId}
        />

        <CardSubcardsSectionHOC
            boardId={boardId}
            cardId={cardId}
        />

        <CardRelatedSectionHOC
            boardId={boardId}
            cardId={cardId}
        />

        <DependenciesSectionHOC
            boardId={boardId}
            cardId={cardId}
        />

        <CustomPropertiesSectionHOC
            boardId={boardId}
            cardId={cardId}
        />

        {!isColumns && <CommentsSectionHOC
            boardId={boardId}
            cardId={cardId}
        />}

        <DeleteButtonSectionHOC
            boardId={boardId}
            cardId={cardId}
        />
    </>;

    const ResizerSvg = require('!!@svgr/webpack!../../../../../../../../../../assets/svg/spreader.svg').default;

    return (
        <div className={`
            ${className}
            ${isColumns ? className + '--columns' : ''}
            ${classNameReadonly}
        `}>
            <ActionsInHeadSectionHOC boardId={boardId} cardId={cardId}/>
            {isColumns ?
                <div className={className + '__body'}>
                    <div className={classContainer}>{body}</div>
                    <div className={classContainer + '-wrapper'}>
                        <Draggable
                            key={resizerKey}
                            axis={'y'}
                            bounds={{
                                left: columnWidthRef.current + resizer.current.actionsWidth - resizer.current.maxWidth,
                                right: columnWidthRef.current + resizer.current.actionsWidth - resizer.current.minWidth,
                                top: 0,
                                bottom: 0,
                            }}
                            onStart={() => {
                                if (root._innerWidth > COMMENTS_COLUMN_VIEW_MIN_WIDTH) {
                                    document.addEventListener('mousemove', onMouseMove);
                                }
                                const aside = document.querySelector('.' + CLASS_ASIDE_PANEL) as HTMLElement;
                                if (aside) {
                                    aside.classList.add(CLASS_ASIDE_PANEL_DRAGGING);
                                }
                            }}
                            onDrag={handleResizerDrag}
                            onStop={handleResizerDragStop}
                        >
                            <div className={className + '__resizer'} ref={resizerRef}>
                                <ResizerSvg/>
                            </div>
                        </Draggable>
                        <div
                            className={`${classContainer} ${classContainer}--comments`}
                            style={{
                                width: columnWidthRef.current - GOOGLE_SPACING * 2.5 + 'px', // - 20px scroll
                            }}
                        >
                            <CommentsSectionHOC
                                boardId={boardId}
                                cardId={cardId}
                            />
                        </div>
                    </div>
                </div>
                : body
            }
        </div>
    );
}
